import { hotTags } from "@/mocks/homeData";
import SectionHeading from "./SectionHeading";

interface TagsSectionProps {
  activeTag: string;
  onPickTag: (tag: string) => void;
}

export default function TagsSection({ activeTag, onPickTag }: TagsSectionProps) {
  const goExplore = (tag: string) => {
    onPickTag(tag);
    document.getElementById("explore")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="tags" className="w-full bg-background-100 py-14 md:py-16">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <SectionHeading
          eyebrow="热门标签"
          title="从一个词出发，发现更多相关内容"
          desc="这些标签来自当下被频繁浏览的内容方向。点选任意标签，会直接跳转到「内容探索」并按该标签筛选，快速进入你想看的主题。"
        />

        <div className="mt-8 flex flex-wrap gap-2.5">
          {hotTags.map((tag) => {
            const isActive = activeTag === tag;
            return (
              <button
                key={tag}
                type="button"
                onClick={() => goExplore(tag)}
                className={`cursor-pointer whitespace-nowrap rounded-full border px-4 py-2 text-sm font-medium transition-colors ${
                  isActive
                    ? "border-primary-500 bg-primary-500 text-background-50"
                    : "border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300 hover:bg-primary-100 hover:text-primary-700"
                }`}
              >
                #{tag}
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}